import { render, staticRenderFns } from "./MemberProfileLoan.vue?vue&type=template&id=2d1b68b0&"
import script from "./MemberProfileLoan.vue?vue&type=script&lang=js&"
export * from "./MemberProfileLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports